<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    aria-hidden="true"
  >
    <circle
      cx="12"
      cy="12"
      r="9.5"
    />
    <path d="M8 14s1.5 2 4 2 4-2 4-2" />
    <circle
      cx="9"
      cy="10"
      r=".8"
      fill="currentColor"
    />
    <circle
      cx="15"
      cy="10"
      r=".8"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconSmile',
  props: {
    size: { type: [String, Number], default: 18 },
    strokeWidth: { type: [String, Number], default: 1.8 },
  },
};
</script>
